<template>
    <div id="main">
        <div class="page" v-show="!rotaAninhada">
            <div class="fase-fenologica vertical-flow">
                <div class="listing-header">
                    <div class="title-breadcrumb">
                        <h1 class="title">
                            {{ $t(`${abrev}-fasefenologica`) }}
                        </h1>
                        <nav class="breadcrumb" aria-label="breadcrumbs">
                            <ul>
                                <li>
                                    <a class="a-inativo">{{
                                        isAgro ? $t('agro') : $t('vendas')
                                    }}</a>
                                </li>
                                <li>
                                    <a class="a-inativo"
                                        >{{ isAgro ? $t('cadastros') : $t('crm') }}
                                    </a>
                                </li>
                                <li>
                                    <a aria-current="page">{{ $t(`${abrev}-fasefenologica`) }}</a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                    <div class="header-buttons">
                        <button
                            v-if="!faseFenologicaIntegracao && permissao.create"
                            class="save-btn"
                            type="button"
                            tag="button"
                            @click="$router.push({ name: `${abrev}-fasefenologica-new` })"
                        >
                            {{ $t('adicionar') }}
                        </button>
                    </div>
                </div>

                <div class="search-and-filter">
                    <div class="search-bar">
                        <search-bar
                            :onSearch="debouncedOnSearch"
                            tooltipLabel="msg-campo-busca-fase-fenologica"
                        />
                    </div>

                    <div class="situacao-select">
                        <label v-text="$t('situacao')" />
                        <v-select
                            ref="situacaoInput"
                            class="is-100"
                            label="label"
                            :options="situacoes"
                            @input="onSituacaoChanged"
                            v-model="situacao"
                        >
                            <template slot="option" slot-scope="option">
                                {{ $t(option.label) }}
                            </template>
                            <template slot="selected-option" slot-scope="option">
                                {{ $t(option.label) }}
                            </template>
                            <template slot="no-options">{{ $t('sem-resultados') }}</template>
                        </v-select>
                    </div>
                </div>

                <div class="registry-wrapper">
                    <container-loader v-if="isLoading && !$store.getters.isLoading" />
                    <empty-table-message v-if="isEmpty" />
                    <b-table
                        v-else
                        :data="allfasefenologica"
                        class="data-table"
                        @sort="sortTable"
                        backend-sorting
                    >
                        <b-table-column
                            v-for="(f, i) in fields"
                            :key="i"
                            :field="f.key"
                            :label="f.key != 'excluir' ? $t(f.key) : ''"
                            :width="f.width"
                            :class="{
                                'excluir-field': f.key == 'excluir',
                                'label-km': f.key == 'label',
                            }"
                            :sortable="f.sortable"
                            :custom-sort="f.sortFn"
                            v-slot="props"
                        >
                            <div v-if="f.key == 'descricao'">
                                <router-link
                                    :to="{
                                        name: `${abrev}-fasefenologica-edit`,
                                        params: { id: props.row.id, descricao: props.row[f.key] },
                                    }"
                                >
                                    <pre>{{ props.row[f.key] }}</pre>
                                </router-link>
                            </div>
                            <div v-else-if="f.key == 'tipo'">
                                <pre>{{ props.row[f.key] }}</pre>
                            </div>
                            <div v-else-if="f.key == 'situacao'">
                                <b-tag
                                    class="table-tag table-tag-full-width"
                                    v-if="props.row[f.key] == 1"
                                    type="is-success"
                                    size="is-medium"
                                    >{{ $t('ativo') }}</b-tag
                                >
                                <b-tag
                                    class="table-tag table-tag-full-width"
                                    v-else
                                    type="is-danger"
                                    size="is-medium"
                                    >{{ $t('inativo') }}</b-tag
                                >
                            </div>
                            <div v-else-if="f.key == 'excluir'">
                                <span v-if="!faseFenologicaIntegracao && permissao.update">
                                    <b-button
                                        v-if="permissao.update"
                                        class="action-button"
                                        :type="
                                            props.row['situacao'] == 1 ? 'is-danger' : 'is-success'
                                        "
                                        :icon-right="
                                            props.row['situacao'] == 1 ? 'delete' : 'check'
                                        "
                                        @click="promptChangeSituacao(props.row)"
                                        v-tippy
                                        :title="
                                            $t(
                                                props.row['situacao'] == 1
                                                    ? 'desativar'
                                                    : 'reativar'
                                            )
                                        "
                                    />
                                </span>
                            </div>
                            <div v-else>
                                {{ props.row[f.key] }}
                            </div>
                        </b-table-column>
                    </b-table>
                    <PaginationViewer
                        class="mb-0"
                        :resetPagination="pagination.resetPagination"
                        :totalItems="pagination.totalRows"
                        :perPageOptions="pagination.perPageOptions"
                        :optionStarted="pagination.optionStarted"
                        @change="updatePagination"
                    />
                </div>
            </div>
        </div>
        <router-view />
    </div>
</template>

<script>
import FaseFenologicaService from '@/services/FaseFenologicaService';
import ContainerLoader from '@/components/content/loader/ContainerLoader';

/* @71139 */
export default {
    beforeRouteUpdate(to, from, next) {
        if (to.name.includes('fasefenologica') && !to.name.includes('fasefenologica-list')) {
            this.rotaAninhada = true;
            next();
        } else {
            this.rotaAninhada = false;
            this.carregarDados(this.pagination.currentPage);
            next();
        }
    },
    components: {
        ContainerLoader,
    },
    data() {
        return {
            rotaAninhada: false,
            faseFenologicaIntegracao: this.$store.state.user.tabelasERPWebServer.includes(
                'AGRO_FASEFENOLOGICA'
            ),
            allfasefenologica: [],
            situacoes: [
                { id: 2, label: 'todos' },
                { id: 1, label: 'ativos' },
                { id: 0, label: 'inativos' },
            ],
            situacao: { id: 2, label: 'todos' },
            service: new FaseFenologicaService(this.$http, this.$router),
            fields: [
                { key: 'codigo', width: 100, sortable: true, sortFn: null },
                { key: 'descricao', width: null, sortable: true, sortFn: null },
                { key: 'situacao', width: 80, sortable: true, sortFn: null },
                { key: 'excluir', width: 70, sortable: false, sortFn: null },
            ],
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            isLoading: false,
            isEmpty: false,
            debouncedOnSearch: null,
            queryFilter: '',
            delete: null,
            permissao: {},
            order: 'desc',
            column: 'DESCRICAO',

            abrev: this.$route.meta.contexto.slice(0, 3),
            isVenda: this.$route.meta.contexto == 'vendas',
            isAgro: this.$route.meta.contexto == 'agro',
        };
    },
    created() {
        if (
            this.$route.name.includes('fasefenologica') &&
            !this.$route.name.includes('fasefenologica-list')
        ) {
            this.rotaAninhada = true;
        } else {
            this.rotaAninhada = false;
        }

        this.pagination.perPage = this.pagination.perPageOptions[this.pagination.optionStarted];

        if (this.isAgro) {
            this.abrev = this.$route.meta.contexto.slice(0, 4);
            this.permissao = this.hasPermissionAccess(
                'agro',
                'agro-cadastros',
                'agro-fasefenologica'
            );
        } else if (this.isVenda) {
            this.permissao = this.hasPermissionAccess('vendas', 'crm', 'ven-fasefenologica');
        }

        if (!this.permissao.read) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: `${this.abrev}-fasefenologica` },
            });
        } else {
            this.debouncedOnSearch = this.debounce(this.onSearch, 500);
            this.carregarDados();
        }
    },
    methods: {
        onSituacaoChanged(val) {
            this.situacao = val
                ? this.situacoes.filter((v) => v.id == val.id)[0]
                : this.situacoes[0];
            this.carregarDados();
        },
        sortTable(field, order) {
            this.column = field;
            this.order = order;
            this.carregarDados();
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        onSearch(value) {
            this.queryFilter = value;
            this.pagination.currentPage = 1;
            this.carregarDados();
        },
        carregarDados(currentPage = 1) {
            if (currentPage == 1 && this.pagination.currentPage != 1)
                this.pagination.resetPagination = true;
            this.isLoading = true;
            this.service
                .findAll(
                    this.column,
                    this.order,
                    currentPage - 1,
                    this.pagination.perPage,
                    this.situacao.id,
                    this.abrev,
                    this.queryFilter
                )
                .then(this.mapItems)
                .then((value) => {
                    this.allfasefenologica = value;
                    this.isEmpty = this.allfasefenologica.length <= 0;
                })
                .catch((e) => {
                    this.isEmpty = true;
                    this.$root.showMessage('error', 'msg-erro-load');
                    console.error('Erro ao carregar as fases fenológicas.');
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.pagination.resetPagination = false;
                });
        },
        mapItems(body) {
            this.pagination.totalRows = body.totalElements;
            return body.content.map((m) => {
                return {
                    id: m.id,
                    codigo: m.idagrofasefenologicaerp,
                    descricao: m.descricao,
                    excluir: 'excluir',
                    situacao: m.situacao,
                };
            });
        },
        promptChangeSituacao(row) {
            this.delete = row;
            let message = this.$t(
                    row.situacao == 1
                        ? 'msg-confirmacao-desativacao-n'
                        : 'msg-confirmacao-reativacao-n', 
                    { n: row.descricao }
                );
            this.$root.confirm({
                message: message,
                onConfirm: this.updateSituacaoRegistro,
                onCancel: this.removePrompt,
            });
        },
        removePrompt() {
            this.delete = null;
        },
        updateSituacaoRegistro() {
            let tempFailure =
                this.delete.situacao == 1
                    ? 'msg-erro-ao-desativar-fase-fenologica'
                    : 'msg-erro-ao-reativar-fase-fenologica';

            let tempFaseFenologica = {
                idagrofasefenologica: this.delete.id,
                situacao: this.delete.situacao == 1 ? 0 : 1,
            };

            this.isLoading = true;

            this.service
                .updateSituacao(tempFaseFenologica, this.abrev)
                .then((r) => {
                    if (r.status == 200) {
                        let tempSuccess =
                            r.content.situacao == 1
                                ? 'msg-sucesso-ao-reativar-fase-fenologica'
                                : 'msg-sucesso-ao-desativar-fase-fenologica';
                        this.$root.showMessage('success', tempSuccess);
                        this.carregarDados(this.pagination.currentPage);
                    } else if (r.status == 500) {
                        this.$root.showMessage('error', 'Erro ao atualizar status.');
                    }
                })
                .catch((e) => {
                    console.error('Erro ao atualizar status.', e);
                    this.$root.showMessage('error', tempFailure);
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.delete = null;
                });
        },
    },
};
</script>

<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: 100%;

    .page {
        position: relative;
        padding-left: 0;

        .table-tag {
            width: 5rem !important;
        }

        .fase-fenologica .search-and-filter {
            display: flex;
            justify-content: space-between;
            margin: 10px 0;

            .search-bar {
                width: 80%;
                padding-right: 10px;
            }
            .situacao-select {
                width: 30%;
                div {
                    height: 40px;
                }
            }
            .filter-bar {
                width: 31%;
            }
            @media (max-width: 760px) {
                .search-bar {
                    padding-right: 0;
                }
                .situacao-select {
                    width: 100%;
                }
            }
        }
    }
}
</style>
